import { useMemo } from "react"
import useConversations from "../../../hooks/use-conversations"

const Options = () => {
  const { threads } = useConversations()
  const brandList = useMemo(() => {
    const brands = Array.isArray(threads)
      ? threads.map(thread => ({
          id: thread.brand_id,
          name: thread.loan_officer.brand_name
        }))
      : []

    return brands.filter(
      (brand, index, self) =>
        index ===
        self.findIndex(t => t.id === brand.id && t.name === brand.name)
    )
  }, [threads])

  return (
    <>
      <option value="">All Brands</option>
      {brandList.map(brand => (
        <option key={brand.id} value={brand.id}>
          {brand.name}
        </option>
      ))}
    </>
  )
}

export default Options
